import React, { Component } from "react";
import PropTypes from "prop-types";

//Actions
import * as ACTIONS from "./../../../../actions/actionConstants";

import { compose } from "redux";
import { connect } from "react-redux";

//MUI
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { withStyles } from "@material-ui/core/styles";

//Util
import classNames from "classnames";

//Components
import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import Tooltip from "rc-tooltip";
import Slider from "rc-slider";

const Handle = Slider.Handle;

const handle = props => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={value}
      visible={dragging}
      placement="top"
      key={index}>
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};

class ControlPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.tempValue || null,
      units: null
    };
  }

  handleChange = (buildingName, name, value) => {
    let objectInstance;
    if (name === "SpaceTemp") {
      objectInstance = "1";
    } else if (name === "RATemp") {
      objectInstance = "2";
    }
    this.setState({
      value: value
    });

    this.props.storeTempPoint(buildingName, objectInstance, value);
    this.props.changeSetpoint(buildingName, objectInstance, value);
  };

  render() {
    const { buildingName, classes, data, name } = this.props;

    return (
      <div className={classes.root}>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography
              className={classNames(classes.heading, {
                [classes.bold]: name === "SpaceTemp" || name === "RATemp"
              })}>
              {String(name).toUpperCase()}
            </Typography>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  className={classNames(classes.secondaryHeading, {
                    [classes.bold]: name === "SpaceTemp" || name === "RATemp"
                  })}>
                  {data.value}
                  {data.units}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className={classNames(classes.tertiaryHeading, {
                    [classes.bold]: name === "SpaceTemp" || name === "RATemp",
                    [classes.warmer]: this.state.value > data.value,
                    [classes.cooler]: this.state.value < data.value
                  })}>
                  {this.state.value}
                  {this.state.value ? "°F" : null}
                </Typography>
              </Grid>
            </Grid>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            {name === "SpaceTemp" || name === "RATemp" ? (
              <Slider
                min={50}
                max={90}
                defaultValue={Number(data.value)}
                handle={handle}
                onAfterChange={value => this.handleChange(buildingName, name, value)}
              />
            ) : (
              <div />
            )}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tempValue: state.temp.changes.tempValue
});

const mapDispatchToProps = dispatch => ({
  changeSetpoint: (buildingName, objectInstance, value) =>
    dispatch({
      type: ACTIONS.CHANGE_SETPOINT,
      payload: { buildingName, objectInstance, value }
    }),
  storeTempPoint: (buildingName, objectInstance, value) =>
    dispatch({
      type: ACTIONS.STORE_TEMP_POINT,
      payload: { buildingName, objectInstance, value }
    })
});

//Styles
const styles = theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "66%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "15%",
    flexShrink: 0
  },
  tertiaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "15%",
    flexShrink: 0
  },
  bold: {
    fontWeight: "bold"
  },
  warmer: {
    color: theme.palette.secondary.main
  },
  cooler: {
    color: theme.palette.primary.main
  }
});

ControlPanel.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles)
)(ControlPanel);



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/dashboard_tabs/Setpoints/ControlPanel.js